import { DetailListModel, ItemTypeModel, Details } from '@leverege/ui-attributes';
import { ValueCache } from '@leverege/value-cache';
const INCLUDE_TAG = 'include:list';
const cache = new ValueCache();
function create(blueprint, subtype) {
  const subId = subtype ? `.${subtype}` : '';
  const type = `${blueprint.type}${subId}`;
  return {
    id: `${blueprint.type}${subId}.ListModelConfigurer`,
    configure: (itemModel, objectType, cxt) => {
      if (type !== objectType) {
        return itemModel;
      }
      if (cache.isSame(blueprint, subtype)) {
        return cache.value;
      }
      const details = [];
      const allDetails = Details.getDetailsFor(`${blueprint.type}${subId}`).map(d => d.create());
      if (subtype === 'history') {
        const timeAttr = allDetails.find(d => d.attrName === `${blueprint.historyType}.time`);
        if (timeAttr) {
          details.push(timeAttr);
        }
      }
      const nameAttr = allDetails.find(d => d.attrName === `${blueprint.type}${subId}.deviceName`);
      if (nameAttr) {
        details.push(nameAttr);
      }
      blueprint.attributes.forEach(attr => {
        if (attr.hasTag(INCLUDE_TAG)) {
          const colAttr = allDetails.find(col => col.attrName === `${blueprint.type}${subId}.${attr.name}`);
          if (colAttr) {
            details.push(colAttr);
          }
        }
      });
      const iM = ItemTypeModel.setDetails(itemModel, DetailListModel.create({
        details
      }));
      return cache.set(iM, blueprint, subtype);
    }
  };
}
const BlueprintAnalyzer = {
  id: 'blueprint.ItemTypeModelConfigurer',
  sort: 100,
  processBlueprints(molten, blueprints) {
    blueprints.forEach(b => {
      molten.addPlugin('ItemTypeModelConfigurer', create(b));
      molten.addPlugin('ItemTypeModelConfigurer', create(b, 'history'));
    });
  }
};
export default {
  create,
  BlueprintAnalyzer
};